import { useMutation } from "@tanstack/react-query";
import { downloadTransactionHifiExcel } from "../api";
import { toast } from "react-toastify";

export const useDownloadTransactionHifiExcel = () => {
  const { mutate: downloadExcel, isPending } = useMutation({
    mutationFn: async ({
      startDate,
      endDate,
    }: {
      startDate?: string;
      endDate?: string;
    }) => {
      const blob = await downloadTransactionHifiExcel(startDate, endDate);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const filename =
        startDate && endDate
          ? `transaction_hifi_${startDate}_to_${endDate}.xlsx`
          : `transaction_hifi.xlsx`;

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Gagal mendownload file. Silakan coba lagi.";
      toast.error(message);
    },
  });

  return { downloadExcel, isPending };
};
